module.exports = __webpack_public_path__ + "img/harmony.43657c2e.png";